import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import imgWebp from '!!file-loader!../../assets/example-file.webp';
import imgPng from '!!file-loader!../../assets/example-file.png';

@Component({
  selector: 'app-helixbook-example-file',
  templateUrl: './example-file.component.html',
  styleUrls: ['./example-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExampleFileComponent {
  @Input() hxid = '';

  imgWebp = imgWebp;
  imgPng = imgPng;

  get link(): string {
    return this.hxid ? `/catalog/downloadexamplefile?hxid=${this.hxid}` : '';
  }
}
